var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.589 6.75c-18.593 0-33.663 15.07-33.663 33.662 0 14.87 9.643 27.49 23.021 31.944 1.684.304 2.292-.732 2.292-1.623 0-.8-.027-2.92-.037-5.724-9.366 2.032-11.344-4.516-11.344-4.516-1.525-3.888-3.736-4.924-3.736-4.924-3.054-2.089.233-2.042.233-2.042 3.382.237 5.154 3.47 5.154 3.47 3.003 5.143 7.884 3.658 9.794 2.798.307-2.177 1.184-3.662 2.143-4.503-7.472-.847-15.33-3.736-15.33-16.638 0-3.669 1.314-6.68 3.457-9.028-.341-.854-1.506-4.28.334-8.91 0 0 2.825-.908 9.254 3.445a32.342 32.342 0 018.424-1.134c2.846.005 5.678.386 8.424 1.134 6.433-4.357 9.254-3.445 9.254-3.445 1.84 4.63.686 8.056.334 8.91 2.16 2.349 3.456 5.356 3.456 9.028 0 12.936-7.863 15.778-15.362 16.611 1.198 1.04 2.278 3.092 2.278 6.23 0 4.503-.04 8.134-.04 9.238 0 .901.6 1.947 2.318 1.617C64.618 67.888 74.25 55.279 74.25 40.412 74.25 21.82 59.18 6.75 40.588 6.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/GitHub.aa820d7ecd26e8315213a0da807c4397.svg";
export { ForwardRef as ReactComponent };